import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-corner",
  "use": "icon-corner-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 6 6\" id=\"icon-corner\">\r\n<path d=\"M5.909,6H0.091V0L5.909,6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol